const COMMUNITY = "Community";
const FLEX = "Flex";
const FREEDOM = "Freedom";
const FREEDOM_V2 = "FreedomV2";
const UNSUPPORTED = "Unsupported";

export { COMMUNITY, FLEX, FREEDOM, FREEDOM_V2, UNSUPPORTED };
